module.exports = __webpack_public_path__ + "static/media/5.41b98044.svg";